module.exports = __webpack_public_path__ + "static/media/icon-minus.90a95593.svg";